import React from 'react';
import { Badge, BadgeProps } from '@mui/material';

interface NotificationBadgeProps extends Omit<BadgeProps, 'badgeContent'> {
  count: number;
  children: React.ReactNode;
  showZero?: boolean;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  children,
  showZero = false,
  ...badgeProps
}) => {
  // Only show badge if count > 0 or showZero is true
  if (count === 0 && !showZero) {
    return <>{children}</>;
  }

  return (
    <Badge
      badgeContent={count}
      color="error"
      sx={{
        '& .MuiBadge-badge': {
          fontSize: '0.6rem',
          minWidth: '14px',
          height: '14px',
          borderRadius: '14px',
          fontWeight: 'bold',
        },
      }}
      {...badgeProps}
    >
      {children}
    </Badge>
  );
};

export default NotificationBadge;
